import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { HOME_DASHBOARD_SECTION_LABELS } from '../../utils/dashboard/homeDashboardLayout';

const DashboardLayoutSection = ({
	section,
	isEditing = false,
	isDragging = false,
	isDragTarget = false,
	canReorder = false,
	onDragHandleStart,
	onDragHandleEnd,
	onToggleHidden,
	onDragEnter,
	onDragOver,
	onDragLeave,
	onDrop,
	children,
}) => {
	const label = HOME_DASHBOARD_SECTION_LABELS[section.id] ?? section.id;

	return (
		<div
			className={classNames('dashboard-layout-section', {
				'dashboard-layout-section--editing': isEditing,
				'dashboard-layout-section--hidden': section.hidden,
				'dashboard-layout-section--dragging': isDragging,
				'dashboard-layout-section--drop-target': isDragTarget,
			})}
			data-dashboard-section-id={section.id}
			onDragEnter={onDragEnter}
			onDragOver={onDragOver}
			onDragLeave={onDragLeave}
			onDrop={onDrop}
		>
			{isEditing ? (
				<header className='dashboard-layout-section__chrome'>
					<div
						className={classNames('dashboard-layout-section__drag-handle', {
							'dashboard-layout-section__drag-handle--disabled': !canReorder,
						})}
						draggable={canReorder}
						onDragStart={canReorder ? onDragHandleStart : undefined}
						onDragEnd={canReorder ? onDragHandleEnd : undefined}
						title={canReorder ? '拖拽调整顺序' : undefined}
					>
						<FontAwesomeIcon icon='grip-lines' />
						<span className='dashboard-layout-section__label'>{label}</span>
						{section.hidden ? <span className='dashboard-layout-section__badge'>已隐藏</span> : null}
					</div>
					<Button
						type='button'
						size='sm'
						variant='link'
						className='dashboard-layout-section__visibility p-0'
						onClick={() => onToggleHidden?.(section.id)}
						title={section.hidden ? '显示此区块' : '隐藏此区块'}
						aria-label={section.hidden ? `显示${label}` : `隐藏${label}`}
					>
						<FontAwesomeIcon icon={section.hidden ? faEyeSlash : faEye} fixedWidth />
					</Button>
				</header>
			) : null}
			<div
				className={classNames('dashboard-layout-section__body', {
					'dashboard-layout-section__body--hidden-preview': isEditing && section.hidden,
				})}
			>
				{children}
			</div>
		</div>
	);
};

DashboardLayoutSection.propTypes = {
	section: PropTypes.shape({
		id: PropTypes.string.isRequired,
		order: PropTypes.number,
		hidden: PropTypes.bool,
	}).isRequired,
	isEditing: PropTypes.bool,
	isDragging: PropTypes.bool,
	isDragTarget: PropTypes.bool,
	canReorder: PropTypes.bool,
	onDragHandleStart: PropTypes.func,
	onDragHandleEnd: PropTypes.func,
	onToggleHidden: PropTypes.func,
	onDragEnter: PropTypes.func,
	onDragOver: PropTypes.func,
	onDragLeave: PropTypes.func,
	onDrop: PropTypes.func,
	children: PropTypes.node,
};

export default DashboardLayoutSection;
